import { Grid2, TextField } from "@mui/material";
import { type Control, Controller } from "react-hook-form";

import type {
	SectionSpecDraftFormValues,
	SectionSpecFormValues,
} from "../../models/SectionSpecForm";

interface SpecFieldProps {
	disabled: boolean;
	error?: boolean;
	field: keyof SectionSpecFormValues;
	helperText?: string;
	label: string;
	value: string;
	onChange?: (value: string) => void;
}

export const SpecField = ({
	disabled,
	error = false,
	field,
	helperText,
	label,
	value,
	onChange,
}: SpecFieldProps) => (
	<Grid2 size={{ xs: 12, sm: 4 }}>
		<TextField
			disabled={disabled}
			label={label}
			type={field === "printNo" ? "text" : "number"}
			size="small"
			fullWidth
			value={value}
			error={error}
			helperText={helperText}
			onChange={(event) => onChange?.(event.target.value)}
			slotProps={{
				htmlInput: {
					...(field === "printNo"
						? {}
						: { step: "any", inputMode: "decimal" as const }),
					"data-test-id": `spec-${field}-input`,
				},
			}}
		/>
	</Grid2>
);

interface ControlledSpecFieldProps {
	control: Control<SectionSpecDraftFormValues>;
	disabled: boolean;
	field: keyof SectionSpecFormValues;
	label: string;
}

const WEIGHT_BAND_FIELDS: Array<keyof SectionSpecFormValues> = [
	"min",
	"target",
	"max",
];

export const ControlledSpecField = ({
	control,
	disabled,
	field,
	label,
}: ControlledSpecFieldProps) => (
	<Controller
		name={field}
		control={control}
		rules={{
			// Band errors can belong to a different field than the one being edited.
			deps: WEIGHT_BAND_FIELDS.includes(field)
				? WEIGHT_BAND_FIELDS.filter((name) => name !== field)
				: undefined,
		}}
		render={({ field: controllerField, fieldState }) => (
			<SpecField
				disabled={disabled}
				field={field}
				label={label}
				value={controllerField.value}
				onChange={controllerField.onChange}
				error={Boolean(fieldState.error)}
				helperText={fieldState.error?.message}
			/>
		)}
	/>
);
